const ActionTypes = {
    SET_SUCCESS_PAGE_VIDEO_URL: 'SET_SUCCESS_PAGE_VIDEO_URL'
};

function setSuccessPageVideoUrl (payload = null) {

    return {
        type: ActionTypes.SET_SUCCESS_PAGE_VIDEO_URL,
        payload
    };
}

export {
    setSuccessPageVideoUrl,
    ActionTypes
};


// WEBPACK FOOTER //
// ./src/js/store/actions/successPage.js